import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import useImgResize from "../../Hook/useImgResize";

function stripHtmlTags(input) {
  // Deterministic linear-time tag stripper (no regex; avoids ReDoS flags)
  if (input == null) return "";
  const s = String(input);

  let out = "";
  let inTag = false;

  for (const ch of s) {
    if (ch === "<") {
      inTag = true;
      continue;
    }
    if (ch === ">") {
      inTag = false;
      continue;
    }
    if (!inTag) out += ch;
  }

  return out;
}

export default function TitleAndLogo({
  logo,
  currentRepo,
  title,
  collection,
  description,
}) {
  const parentRef = useRef(null);
  const imgRef = useRef(null);
  const logoURL = `${process.env.REACT_APP_API_BASE}${logo}`;
  let styling = useImgResize(parentRef, imgRef);

  const pageTitle = stripHtmlTags(collection);
  let docTitle = `${pageTitle} - TARO`.trim();
  let pageUrl = window.location.href;

  document.title = docTitle;

  return (
    <div className="findingaid-header">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{docTitle}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={pageUrl} />
      </Helmet>
      <div ref={parentRef}>
        {logo && (
          <Link to={`/repositories/${currentRepo}`}>
            <img
              ref={imgRef}
              src={`${logoURL}`}
              alt={`${title} repository information`}
              style={styling}
            />
          </Link>
        )}
      </div>
      <h1
        className="card-title findingaid-title"
        tabIndex="0"
        dangerouslySetInnerHTML={{
          __html: collection,
        }}
      ></h1>
    </div>
  );
}
